import {FC, useRef, useState} from 'react';
import {Box, Center, Stack} from '@chakra-ui/react';
import {api, IAgentTask, useT} from '@kcast-fe/core';
import {Loader, Modal, SearchInputBig} from 'ui-kit';

import {AgentTaskEditorModal, AgentTaskItem} from './components';

const MAX_WIDTH = {base: '796px', smToMd: 'calc(100% - 12px)'};

const AgentTasksSceneFC: FC = () => {
  const ref = useRef<HTMLDivElement | null>(null);

  const {data: tasks = [], isLoading} = api.agentTasks.useAgentTasksQuery();

  const [query, setQuery] = useState('');
  const [editingTask, setEditingTask] = useState<IAgentTask | null>(null);

  const {t} = useT();

  const filteredTasks = query
    ? tasks.filter((task) => {
        const haystack = `${task.prompt} ${task.agent_id ?? ''}`.toLowerCase();
        return haystack.includes(query.toLowerCase());
      })
    : tasks;

  return (
    <Modal isOpen isFullHeight title={t('agentTasks.title')} maxW={MAX_WIDTH}>
      <Box ref={ref} h={'calc(100% - 24px)'} overflow={'hidden'}>
        <Stack h={'100%'} gap={'0'} pt={'12px'}>
          {tasks.length > 0 && (
            <Box p={'6px 24px'}>
              <SearchInputBig value={query} onChange={setQuery} />
            </Box>
          )}

          <Box flex={'1 1 auto'} overflowY={'auto'} p={'0 24px'}>
            {isLoading && (
              <Center h={'100%'}>
                <Loader size={'lg'} />
              </Center>
            )}

            {!isLoading && tasks.length === 0 && (
              <Center
                flexDirection={'column'}
                gap={'24px'}
                h={'100%'}
                textAlign={'center'}
                p={'0 24px'}
              >
                <Box fontWeight={'500'} color={'{colors.textPrimary}'}>
                  {t('agentTasks.list.empty')}
                </Box>
                <Box color={'{colors.textSecondary}'} maxW={'400px'}>
                  {t('agentTasks.list.emptyDescription')}
                </Box>
              </Center>
            )}

            {!isLoading && (
              <Box px={'6px'}>
                {filteredTasks.map((task) => (
                  <AgentTaskItem
                    key={task.id}
                    task={task}
                    containerRef={ref}
                    onEdit={setEditingTask}
                  />
                ))}
              </Box>
            )}
          </Box>
        </Stack>
      </Box>

      <AgentTaskEditorModal
        isOpen={Boolean(editingTask)}
        task={editingTask}
        onClose={() => setEditingTask(null)}
      />
    </Modal>
  );
};

export const AgentTasksScene = AgentTasksSceneFC;
